@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading service-title">{{ 'administration.service.drawings' | translate }}</h2>
</div>

<div class="styling-wrapper">
	<h2 class="mat-heading">Styling</h2>
	<div class="styling-sections">
		<section class="styling-section">
			<div class="actions form-actions--gap">
				<h3 class="styling-label">Color:</h3>
				<button mat-flat-button color="primary" type="button" (click)="uploadColor()">Upload</button>
				<button mat-flat-button color="primary" type="button" (click)="downloadColor()">Download</button>
			</div>
		</section>

		<section class="styling-section">
			<div class="actions form-actions--gap">
				<h3 class="styling-label">Custom:</h3>
				<button mat-flat-button color="primary" type="button" (click)="uploadCustom()">Upload</button>
				<button mat-flat-button color="primary" type="button" (click)="downloadCustom()">Download</button>
			</div>
		</section>
	</div>
</div>
